import React, { useEffect, useState } from 'react'
import Input from '../Input/Input'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import Style from './ProductCounter.module.css'
import { useForm } from 'react-hook-form'
const ProductCounter = (props) => {
    const[number,setNumber]=useState(0)
    useEffect(()=>{
        setNumber(props.CountProduct)    
    },[props.CountProduct])
   
    const inputChangedHandler = () => {}
    
    const AddCountHandler=()=>{
        if(props.CountProduct===props.maxCount){
            setNumber(props.maxCount)
        }else{
            setNumber(parseInt(number)+1)
            props.GetCount(parseInt(number)+1)
        }
        
    }
    const MinusCountHandler=()=>{
        setNumber(parseInt(number)-1)
        props.GetCount(parseInt(number)-1)
    }

    const {register,handleSubmit } = useForm();
    const onSubmit = (data) => {}
    
    return (
        <div className={Style.ProductCounterHolder}>
            <form onSubmit={handleSubmit(onSubmit)} className={Style.formCounterHolder}>
            <div className={props.CountProduct===props.maxCount?Style.disable:Style.plus} onClick={AddCountHandler}>< FontAwesomeIcon icon={faPlus} /></div>
                <Input  {...register('counter',{ required: true })} inputtype={'counter'} type={'number'} value={number}  onChange={(event)=>inputChangedHandler(event)}/>
            <div className={Style.Minus} onClick={MinusCountHandler} > <FontAwesomeIcon icon={faMinus}/></div>
            </form>
        </div>
    )
}
export default ProductCounter
